var _defs, _path, _rect, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1860d3;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.89,92.47c-.1-.87-.16-1.76-.16-2.65-.05-12.66,10.2-22.97,22.86-23h.1c12.71-.02,23,10.27,23.02,22.97,0,.91-.05,1.8-.16,2.69M88.37,92.47v-8.54c0-.36-.29-.64-.65-.64l-4.21.06c-1.08-.38-2.18-.77-3.26-1.15-.49-.16-.85-.54-.99-1.03-.87-2.3-1.88-4.57-2.81-6.85-.14-.38-.14-.82,0-1.2,1.12-2.42,2.27-4.83,3.44-7.24.02-.02.02-.03.03-.05.31-.44.19-1.05-.24-1.34-1.9-1.87-3.8-3.75-5.67-5.67-.31-.42-.89-.51-1.31-.21-2.28,1.15-4.66,2.25-6.99,3.38-.49.28-1.1.28-1.59,0-2.15-.99-4.34-1.94-6.56-2.79-.56-.14-.99-.54-1.17-1.08-.92-2.72-1.9-5.41-2.88-8.11-2.98,0-5.95.02-9,.17-.51-.07-.98.28-1.06.78-.84,2.51-1.73,4.99-2.65,7.45-.21.4-.54.72-.94.91-2.27.98-4.57,1.88-6.84,2.88-.42.23-.91.23-1.33,0-2.37-1.15-4.76-2.25-7.13-3.42-.44-.33-1.06-.23-1.4.21-1.87,1.87-3.73,3.73-5.58,5.6-.45.31-.54.94-.23,1.4,1.15,2.28,2.23,4.64,3.38,6.97.23.47.24,1.01.02,1.49-1.02,2.19-1.95,4.43-2.82,6.68-.12.52-.51.94-1.01,1.1-1.33.45-2.64.93-3.96,1.4-.81.29-1.35,1.05-1.35,1.91v6.94"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.53,
    y: 7.53,
    width: 84.93,
    height: 84.93
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.7 29.04 19.48 29.04 25.74 17.85 33.42 45.72 40.57 28.49 50 28.49 58.72 17.85 66.6 42.06 72.65 27.02 86.59 27.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIcon3);
export default __webpack_public_path__ + "static/media/benefit-icon-3.ee22a0cbf76257c300766c8b5f751142.svg";
export { ForwardRef as ReactComponent };